import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/Competence/CompetenceDirectoryApi";
import store from "../../../../Frontends/Common/store";
export class CompetenceDirectoryService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editCompetenceDirectory", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editCompetenceDirectory");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getCompetenceDirectories", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getCompetenceDirectory", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createCompetenceDirectory", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteCompetenceDirectory", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editCompetenceDirectory", model);
  }
  async export(filter, format) {
    let role = JSON.parse(localStorage.getItem("userRole")).systemName;
    const res = this.Api.export(filter, role, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
